import { render, staticRenderFns } from "./ResourceEffort.vue?vue&type=template&id=6fd4b722"
import script from "./ResourceEffort.vue?vue&type=script&lang=js"
export * from "./ResourceEffort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports